<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-log-list" class="ag-grid-container">

    <div class="vx-card">
      <grid-action-bar
          :show-deleted="false"
          v-on:update:search="searchQuery = $event"
          title="User Sync"
      >
        <template slot="right">
          <div class="mr-4">
            <ul>
              <li><strong>Total:</strong> {{data.length}}</li>
            </ul>
          </div>
          <div>
            <ul>
              <li><strong>Mismatched values:</strong> {{mismatched.length}}</li>
              <li><strong>Missing in CMI:</strong> {{cmiMissing.length}}</li>
              <li><strong>Missing in Auth0:</strong> {{externalMissing.length}}</li>
            </ul>
          </div>
        </template>
      </grid-action-bar>

      <!-- AgGrid Table -->
      <t-grid
          :column-defs="columnDefs"
          class="lg"
          :data="data"
          :loading="loading"
          :search="searchQuery"
          auto-size
      />
    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import GridActionBar from "@/views/components/extra-components/GridActionBar";
import CellMatchingMixin from "@/views/pages/sync/CellMatchingMixin";

export default {
  components: {
    TGrid,
    GridActionBar,
  },
  mixins: [CellMatchingMixin],
  data () {
    return {


      searchQuery: '',
      showDeleted: false,

      // AgGrid
      columnDefs: [
        {
          headerName: 'ID',
          field: 'Contact_PK',
          filter: 'agTextColumnFilter',
          width: 310,
          maxWidth: 350,
          sortable: true,
          sort: 'desc',
        },
        {
          headerName: 'Company',
          field: 'company.CompanyName',
          filter: 'agTextColumnFilter',
          width: 200,
        },
        {
          headerName: 'CMI - First Name',
          field: 'FirstName',
          filter: 'agTextColumnFilter',
          width: 200,
          cellClass: (params, match = this.getExternalValue(params, 'given_name')) =>
              this.matchingCellStyle(params, match)
        },
        {
          headerName: 'CMI - Last Name',
          field: 'LastName',
          filter: 'agTextColumnFilter',
          width: 200,
          cellClass: (params, match = this.getExternalValue(params, 'family_name')) =>
              this.matchingCellStyle(params, match)
        },
        {
          headerName: 'CMI - Email',
          field: 'EmailAddress',
          filter: 'agTextColumnFilter',
          width: 200,
          cellClass: (params, match = this.getExternalValue(params, 'email')) =>
              this.matchingCellStyle(params, match)

        },
        {
          headerName: 'CMI - Enabled',
          field: 'IsEnabled',
          width: 200,
          cellClass: (params, match = this.getExternalValue(params, 'disabled')) =>
              this.nonMatchingCellStyle(params, match)
        },
        {
          headerName: 'SSO - First Name',
          field: 'ExternalIdentity.given_name',
          filter: 'agTextColumnFilter',
          width: 200,
          cellClass: (params, match = params.data.FirstName) =>
              this.matchingCellStyle(params, match)
        },
        {
          headerName: 'SSO - Last Name',
          field: 'ExternalIdentity.family_name',
          filter: 'agTextColumnFilter',
          width: 200,
          cellClass: (params, match = params.data.LastName) =>
              this.matchingCellStyle(params, match)
        },
        {
          headerName: 'SSO - Email',
          field: 'ExternalIdentity.email',
          filter: 'agTextColumnFilter',
          match: 'EmailAddress',
          width: 200,
          cellClass: (params, match = params.data.EmailAddress) =>
              this.matchingCellStyle(params, match)
        },
        {
          headerName: 'SSO - Enabled',
          field: 'ExternalIdentity.disabled',
          width: 200,
          valueGetter: ({ value }) => value !== false,
          cellClass: (params, match = params.data.IsEnabled) =>
              this.matchingCellStyle(params, match)
        },
      ],
      // Cell Renderer Components
      data: [],
      loading: false,
    }
  },
  computed: {
    mismatched() {
      return this.data.filter(({HasFalseMatch}) => HasFalseMatch);
    },
    cmiMissing() {
      return this.data.filter(({Contact_PK}) => !Contact_PK);
    },
    externalMissing() {
      return this.data.filter(({ExternalIdentity}) => !ExternalIdentity);
    }
  },
  mounted() {
    this.list();
  },
  methods: {
    updateSearchQuery (val) {
      this.searchQuery = val;
    },
    getExternalValue({data}, key) {
        if (data.ExternalIdentity && data.ExternalIdentity[key]) {
          return data.ExternalIdentity[key];
        }
        return null;
    },
    async list() {
      try {
        this.loading = true;
        const { data } = await this.$api.sync.users.list();
        this.data = data.data
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
}

</script>

<style lang="scss">
</style>
